<template>
    <div>
        <app-navbar v-if="!embed"/>
        <project-navbar
            @information="showShareModal = true"
        />
        <div :style="projectBackgroundStyle" class="is-clipped" :class="embed?'lb-embed-height':'lb-full-height'">
            <slot @share="showShareModal = true"></slot>
        </div>
        <project-modal-resume
            v-if="showResumeModal"
            :show-navigation-buttons="false"
            :project-source="$store.getters.project"
            @share="showShareModal = true"
            @close="showResumeModal = false"
            class="project-resume"
        />
        <project-modal-share
            v-if="showShareModal"
            :content="$store.getters.project"
            @close="showShareModal = false"
            class="project-resume"
            :show-links="false"
        ></project-modal-share>
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar';
import ProjectNavbar from '@/components/ProjectNavbar';
//import ProjectModalResume from '@/components/ProjectModalResume';
import ProjectModalShare from '@/components/ProjectModalShare';
import { projectBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    components: {
        AppNavbar,
        ProjectNavbar,
        //ProjectModalResume,
        ProjectModalShare,
    },
    data() {
        return {
            showResumeModal: false,
            showShareModal: false,
            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,
        };
    },
    computed: {
        isMap() {
            return this.$store.getters.project.mode=="map" || this.$store.getters.project.type=="treasurehunt";
        },
        projectBackgroundStyle() {
            // console.log("finding background")
            if(this.isMap){
                return "background: transparent;";
            }else{
                const bg = this.$store.getters.projectBackground;
                const bgImage = this.$store.getters.projectBackgroundImage;
                if (!bg && !bgImage) {
                    return projectBackground('default');
                }
                return projectBackground(_.isEmpty(bgImage) ? bg : bgImage);
            }
            
        },
    },
    methods: {},
    beforeCreate() {
        if(this.$route.meta.embed){
            document.body.classList.remove('has-navbar-fixed-top');
        }
        
    },
    destroyed() {
        if(this.$route.meta.embed){
            document.body.classList.add('has-navbar-fixed-top');
        }
    },
};
</script>

